module.exports = __webpack_public_path__ + "static/media/LongLogo-2x.fea5dff6.png";